export const LogoMark = ({ size = 28, dark = false }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" data-testid="logo-mark">
    <path d="M5 28V15L16 5.5L27 15V28H5Z" stroke={dark ? "#FFFFFF" : "#0F3D2E"} strokeWidth="2.6" strokeLinejoin="round" />
    <path d="M16 23V11M11.5 15.5L16 11L20.5 15.5" stroke={dark ? "#C6F24E" : "#0F3D2E"} strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ size = 28, dark = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <LogoMark size={size} dark={dark} />
    <span className="font-display text-[1.2rem] leading-none tracking-[-0.03em] sm:text-[1.35rem]">
      <span className={dark ? "text-white" : "text-[var(--charcoal)]"}>Place</span>
      <span className={dark ? "text-[var(--lime)]" : "text-[var(--green)]"}>Backer</span>
    </span>
  </span>
);
